import api from './apiService';

class GradeInstance {
  static get() {
    return api.get('/grade_instances');
  }
}

export default GradeInstance;



// WEBPACK FOOTER //
// ./src/api/gradeInstanceApi.js